var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wordspotting-list",attrs:{"aria-label":"Wordspotting List"}},_vm._l((_vm.words),function(word){return _c('div',{staticClass:"wordspotting-word"},[_vm._v("\n    "+_vm._s(word)+"\n  ")])}))}
var staticRenderFns = []

export { render, staticRenderFns }